import {AssessableAnswerService, AssessmentAnswerService} from "./assessment-answer.service";
import {AssessableContextService, AssessmentContextService} from "./assessment-context.service";
import {Provider} from "@angular/core";
import {AssessableUiService} from "./assessable-ui.service";
import {AssessableProxyService} from "./assessable-proxy.service";
import {ChecklistAnswerService} from "./checklist-answer.service";
import {ChecklistContextService} from "./checklist-context.service";

export function configureAssessmentProviders(): Provider[] {
	return [
		AssessmentAnswerService,
		{
			// We provide the base AssessmentAnswerService here,
			// so that we don't have to depend on a concrete type of assessable (e.g. in the GroupPanel).
			provide: AssessableAnswerService,
			useExisting: AssessmentAnswerService,
		},
		AssessmentContextService,
		{
			// We provide the base AssessableFormStateService here,
			// so that we don't have to depend on a concrete type of assessable (e.g. in the GroupPanel).
			provide: AssessableContextService,
			useExisting: AssessmentContextService,
		},
		{
			provide: AssessableUiService,
		},
		{
			provide: AssessableProxyService,
		},
	];
}

export function configureChecklistProviders(): Provider[] {
	return [
		ChecklistAnswerService,
		{
			// We provide the base AssessmentAnswerService here,
			// so that we don't have to depend on a concrete type of assessable (e.g. in the GroupPanel).
			provide: AssessableAnswerService,
			useExisting: ChecklistAnswerService,
		},
		ChecklistContextService,
		{
			// We provide the base AssessableFormStateService here,
			// so that we don't have to depend on a concrete type of assessable (e.g. in the GroupPanel).
			provide: AssessableContextService,
			useExisting: ChecklistContextService,
		},
		{
			provide: AssessableUiService,
		},
		{
			provide: AssessableProxyService,
		},
	];
}
